module.exports = __webpack_public_path__ + "img/Moon-Phase.b0c953da.jpg";